const STORYBLOK_TOKEN = "YkDSpnxrre5LFchJQ8AeQQtt";
const SHOPIFY_LOCALE = Shopify.locale == "fr" ? "" : `/${Shopify.locale}`;
const parser = new DOMParser();
const liquidEngine = new liquidjs.Liquid();
class STBRenderer {
  constructor(accessToken, rendererContainerSelector) {
    this.client = new StoryblokClient({ accessToken: STORYBLOK_TOKEN });
    this.templates = parser.parseFromString(document.querySelector("#sb-templates").innerHTML, "text/html");
    this.client.setComponentResolver((component, block) => {
      switch (component) {
        case "heading":
          return ` <${block.main_title_level} style="color: ${block.main_title_color.color}" class="${block.main_title_font ? block.main_title_font : ""}">${block.main_title_text}</${block.main_title_level}>`;
      }
    });
    if (document.querySelector(rendererContainerSelector)) {
      this.container = document.querySelector(rendererContainerSelector);
    } else {
      throw new Error("Render element unknown (" + rendererContainerSelector + ")");
    }
    this.registerLiquidTags();
    this.registerLiquidFilters();
  }
  /**
   * Render the component passed in parameter
   * @param component
   * @param appendToContainer
   * @param container
   * @returns {*}
   */
  render(component, appendToContainer = true, container = this.container) {
    const componentIdentifier = component.component;
    if ("content" in document.createElement("template") && this.templates.querySelector("template#" + componentIdentifier)) {
      const template = this.templates.querySelector("template#" + componentIdentifier);
      const cloneDOM = parser.parseFromString(template.innerHTML, "text/html").body;
      const identifier = "block-" + Math.random().toString(36).slice(2);
      cloneDOM.children[0].id = identifier;
      const liquidVariables = this.getComponentVariables(component);
      console.groupCollapsed("❇️" + componentIdentifier);
      console.log("Available liquid variable", liquidVariables);
      console.groupEnd();
      const output = liquidEngine.renderSync(liquidEngine.parse(cloneDOM.outerHTML), liquidVariables);
      if (appendToContainer) {
        container.insertAdjacentHTML("beforeend", output);
        const addedElement = container.querySelector("#" + identifier);
        const event = new CustomEvent("cms:block:rendered", {
          detail: {
            element: addedElement,
            identifier
          }
        });
        document.dispatchEvent(event);
      } else {
        return output;
      }
    } else {
      console.error(
        "<template/> tag is not available in your browser or " + componentIdentifier + " template has not been found."
      );
    }
  }
  getComponentVariables(component, exclude = ["content"]) {
    const output = {};
    for (const [key, value] of Object.entries(component)) {
      if (!exclude.includes(key)) {
        output[key] = value;
      }
    }
    return output;
  }
  registerLiquidFilters() {
    liquidEngine.registerFilter("rich_text", (c) => this.renderRichText(c));
    liquidEngine.registerFilter("storyblok_url", (c, sizes) => this.storyblokUrl(c, sizes));
  }
  registerLiquidTags() {
    liquidEngine.registerTag("block", {
      parse: function(token, remainTokens) {
        this.block = token.args;
      },
      render: function(ctx) {
        console.log(ctx);
        const stbRenderer = new STBRenderer(STORYBLOK_TOKEN, "#cms-headless");
        const block = JSON.parse(ctx.scopes[0].sectionObject);
        return stbRenderer.render(block, false);
      }
    });
  }
  renderRichText(content) {
    return this.client.richTextResolver.render(content);
  }
  storyblokUrl(url, sizes) {
    const imageResource = url;
    const newUrl = imageResource + "/m/" + sizes + "/filters:format(webp)";
    return newUrl;
  }
  static getSTBQuery() {
    const stbQueries = document.querySelector("[data-stb-queries]");
    return stbQueries !== null ? stbQueries.dataset.stbQueries : false;
  }
  static getSTBEndpoint() {
    const stbEndpoint = document.querySelector("[data-stb-endpoint]");
    return stbEndpoint !== null ? stbEndpoint.dataset.stbEndpoint : false;
  }
}
const getBlocks = (endpoint, version = "published") => new Promise((resolve, reject) => {
  const url = `https://api.storyblok.com/v1/cdn/stories${SHOPIFY_LOCALE}/${endpoint}?token=${STORYBLOK_TOKEN}&version=${version}&time=${Date.now()}`;
  fetch(url).then((response) => response.json()).then((json) => {
    resolve(json.story.content.body);
  });
});
const getBlocksForQuery = async (query, version = "published") => {
  const url = `https://api.storyblok.com/v1/cdn/stories/?token=${STORYBLOK_TOKEN}&version=${version}&time=${Date.now()}&${query}`;
  const response = await (await fetch(url)).json();
  if (response.stories.length !== 0) {
    return response.stories[0].content;
  }
};
const getBlocksForMultipleQueries = async (queries, version = "published") => {
  let stbBlocks = [];
  for (const query of queries) {
    const response = await getBlocksForQuery(query, version);
    if (response) {
      const stbComponents = response.body;
      stbBlocks.push({
        component: stbComponents,
        order: Number(response.complement_produit_position)
      });
    }
  }
  stbBlocks = stbBlocks.sort((a, b) => a.order - b.order);
  const stbRenderer = new STBRenderer(STORYBLOK_TOKEN, "#cms-headless");
  stbBlocks.map((stpComponents) => {
    stpComponents.component.map((stpComponent) => {
      stbRenderer.render(stpComponent);
    });
  });
  initFairlyMade();
};
const initSlider = () => {
  const blocksTable = document.querySelectorAll(".section-table");
  if (blocksTable.length) {
    for (let i = 0; i < blocksTable.length; i++) {
      let sliderIndex = 0;
      const columns = blocksTable[i].querySelectorAll(".product-table__column");
      const arrowLeft = blocksTable[i].querySelector(".product-table__arrow--left");
      const arrowRight = blocksTable[i].querySelector(".product-table__arrow--right");
      let sliderIndexMax = columns.length - 1;
      arrowLeft.addEventListener("click", () => {
        columns[sliderIndex].classList.remove("product-table__column--active");
        sliderIndex == 0 ? sliderIndex = sliderIndexMax : sliderIndex = sliderIndex - 1;
        columns[sliderIndex].classList.add("product-table__column--active");
      });
      arrowRight.addEventListener("click", () => {
        columns[sliderIndex].classList.remove("product-table__column--active");
        sliderIndex == sliderIndexMax ? sliderIndex = 0 : sliderIndex = sliderIndex + 1;
        columns[sliderIndex].classList.add("product-table__column--active");
      });
    }
  }
};
const initFairlyMade = () => {
  const fairlyMadeOpeners = document.querySelectorAll(".js-open-fairly-made");
  fairlyMadeOpeners.forEach((fairlyMadeOpener) => {
    fairlyMadeOpener.addEventListener("click", () => {
      window.dialog.showModal();
    });
  });
};
const fetchBlocks = (version = "published") => {
  const stbQueries = STBRenderer.getSTBQuery();
  const stbEndpoint = STBRenderer.getSTBEndpoint();
  if (!stbEndpoint && !stbQueries) return null;
  if (stbEndpoint) {
    getBlocks(stbEndpoint, version).then(async (stbComponents) => {
      const stbRenderer = new STBRenderer(STORYBLOK_TOKEN, "#cms-headless");
      stbComponents.map((stpComponent) => {
        stbRenderer.render(stpComponent);
      });
      initSlider();
      initFairlyMade();
    });
  } else if (stbQueries) {
    const queries = stbQueries.split(";");
    getBlocksForMultipleQueries(queries, version);
  }
};
document.addEventListener("DOMContentLoaded", async () => {
  const { StoryblokBridge } = window;
  const storyblokInstance = new StoryblokBridge();
  storyblokInstance.pingEditor(() => {
    if (storyblokInstance.isInEditor()) {
      fetchBlocks("draft");
    } else {
      fetchBlocks();
    }
  });
  storyblokInstance.on(["input", "published", "change"], (event) => {
    if (event.action === "input") {
      document.querySelector("#cms-headless").innerHTML = "";
      const stbRenderer = new STBRenderer(STORYBLOK_TOKEN, "#cms-headless");
      event.story.content.body.map((stpComponent) => {
        stbRenderer.render(stpComponent);
      });
    } else {
      window.location.reload();
    }
  });
});
